import {
  checkABNNumber,
  checkAEBNNumber,
  checkIDBNNumber,
  checkINTaxData,
  checkKRBNNumber,
  checkMXBNNumber,
  checkSABNNumber,
  checkSGBNNumber,
  checkZABNNumber
} from './tax-number-validation'
import { isINTaxExempt } from './tax'

export const TAX_ID_STATUS = {
  VERIFIED: 'verified',
  FAILED: 'failed'
}

export const TAX_TYPE = {
  INPUT: 'input',
  DROPDOWN: 'dropdown'
}

export const TAX_PREFIX = {
  GR: 'EL',
  MC: 'FR',
  IM: 'GB'
}

export const EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'SE',
  'MC',
  'IM',
  'GB'
]

export const ONLINE_VALIDATION_COUNTRIES = [
  'KZ',
  'MD',
  'BD',
  'CM',
  'AU',
  'UG',
  'TW',
  'BH',
  'IS',
  'RU',
  'VN',
  'SG',
  'BY',
  'CL',
  'CO',
  'NO',
  'SA',
  'OM',
  'TH',
  'IN'
]

export const NO_PREFIX_COUNTRY = ['GR', 'LI', 'MC', 'IM', 'SG', 'AU', 'RU', 'IN']

export const taxConfigurationGetter = (translate) => ({
  AM: {
    message: translate('billing.amMsg'),
    placeholder: translate('billing.vat_registration_placeholder'),
    checkbox: translate('billing.registered_for_vat'),
    tooltip: translate('billing.amMsgDesc'),
    validation: /^\d{8}\/1$/,
    revert: true,
    isEmptiable: true,
    ignorePrefix: true
  },
  AU: {
    message: translate('billing.not_gst_tips_for_au'),
    prefix: 'GST',
    placeholder: translate('billing.gst_number'),
    checkbox: translate('billing.not_gst_registered'),
    tooltip: translate('billing.gst_checkbox_desc'),
    validation: checkABNNumber,
    ignorePrefix: true
  },
  BS: {
    message: translate('billing.vat_header_val_BS'),
    placeholder: 'TIN',
    validation: /^\d{9}$/,
    ignorePrefix: true,
    isEmptiable: true
  },
  BH: {
    message: translate('billing.vat_header_val_BH'),
    placeholder: translate('billing.vat_id_number_placeholder'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_IS_BH'),
    validation: /^\d{15}$/
  },
  BD: {
    message: translate('billing.vat_header_val_BD'),
    placeholder: 'BIN',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_BD')
  },
  BB: {
    message: translate('billing.vat_header_val_BB'),
    placeholder: translate('billing.vat_number'),
    validation: /^\d{13}$/,
    taxExempt: true,
    isEmptiable: true
  },
  BY: {
    message: translate('billing.vat.msg_by'),
    placeholder: translate('billing.tin_number'),
    checkbox: translate('billing.vat.checkbox_by'),
    tooltip: translate('billing.vat.tooltip_by'),
    validation: /^\d{9}$/
  },
  CO: {
    message: translate('billing.vat.msg_co'),
    placeholder: translate('billing.vat.placeholder_co'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat.tooltip_co'),
    validation: /^\d{9}-\d$/,
    isEmptiable: true
  },
  KH: {
    message: translate('billing.vat_header_val_KHM'),
    placeholder: 'TIN',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_KHM'),
    validation: /^[LlKk]00\d-\d{9}$|^[Ee]00\d-\d{10}$/
  },
  CM: {
    message: translate('billing.vat_header_val_CM'),
    placeholder: 'NIU',
    taxExempt: false,
    isEmptiable: true
  },
  CL: {
    message: translate('billing.tax_promote_cl'),
    placeholder: translate('billing.rut_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat.tooltip_cl'),
    validation: /^(\w{9})$/,
    ignore: /-|\s|\./g
  },
  EG: {
    message: translate('billing.vat.tax_promote_eg'),
    placeholder: translate('billing.vat.tax_registration_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat.tooltip_eg'),
    validation: /^\d{3}-\d{3}-\d{3}$|^\d{3}\/\d{3}\/\d{3}$/
  },
  GE: {
    message: translate('billing.vat_header_val_GE'),
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message', [translate('billing.vat_checkout_popup_message_GE')]),
    validation: /^\d{9}$/
  },
  GH: {
    message: translate('billing.vat_header_val_GH'),
    placeholder: 'TIN',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_IS_BH'),
    validation: /^[CV]\d{10}$/
  },
  IS: {
    message: translate('billing.vat_header_val_IS'),
    placeholder: translate('billing.vat_id_number_placeholder'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_IS_BH'),
    validation: /^\d{5}$|^\d{6}$/
  },
  IN: {
    message: translate('billing.inMsg'),
    placeholder: translate('billing.gst_number'),
    tooltip: translate('billing.gst_checkbox_desc_template', [translate('billing.tax_checkbox_desc_non_inr_in')]),
    validation: /^\d{2}[A-Za-z0-9]{13}$/,
    taxExempt: isINTaxExempt,
    taxDataValidation: checkINTaxData,
    isEmptiable: true,
    revert: true
  },
  ID: {
    message: translate('billing.tax_promote_vat_cat1'),
    placeholder: translate('billing.vat_number'),
    validation: checkIDBNNumber,
    isEmptiable: true
  },
  JP: {
    message: translate('billing.tax_number_on_invoice_tips'),
    placeholder: 'JCT Number (Optional)',
    isEmptiable: true
  },
  KZ: {
    message: translate('billing.vat_header_val_KAZ'),
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message', [translate('billing.vat_checkout_popup_message_KAZ')]),
    validation: /^\d{12}$/
  },
  KE: {
    message: translate('billing.keMsg'),
    placeholder: translate('billing.pin_number'),
    validation: /^[AP][0-9]{9}[A-Z]$/,
    isEmptiable: true
  },
  KR: {
    message: translate('billing.vat.msg_kr'),
    prefix: 'KR',
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat.vat_cat2_checkbox_desc'),
    validation: checkKRBNNumber
  },
  LI: {
    message: translate('billing.tax_promote_vat_cat1'),
    prefix: 'MWST',
    placeholder: translate('billing.vat_number'),
    validation: /^\d{5}$/,
    isEmptiable: true
  },
  MY: {
    message: translate('billing.tax_promote_my'),
    suffix: 'SST',
    placeholder: 'SST Number',
    isEmptiable: true
  },
  SN: {
    message: translate('billing.vat_SN_message'),
    placeholder: translate('billing.vat_SN_placeholder'),
    validation: /^[0-9]{9} ?[012][a-zA-Z][0-9]$/,
    isEmptiable: true
  },
  MX: {
    message: translate('billing.tax_promote_vat_cat1'),
    placeholder: translate('billing.vat_number'),
    validation: checkMXBNNumber,
    isEmptiable: true
  },
  MD: {
    message: translate('billing.tax_number_promote.default'),
    placeholder: 'TIN',
    checkbox: translate('billing.tax_checkbox_md'),
    tooltip: translate('billing.mdMsgDesc'),
    validation: /^1\d{12}$/
  },
  NG: {
    message: translate('billing.ngMsg'),
    placeholder: translate('billing.tin_number'),
    validation: /^[0-9]{8}-[0-9]{4}$/,
    isEmptiable: true
  },
  NO: {
    message: translate('billing.tax_promote_no'),
    placeholder: translate('billing.mva_number'),
    suffix: 'MVA',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.tax_checkbox_desc_template', [translate('billing.tax_checkbox_desc_no')]),
    validation: /^\d{9}$/
  },
  OM: {
    message: translate('billing.vat_header_val_OM'),
    placeholder: translate('billing.vat_number'),
    prefix: 'OM',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message', [translate('billing.vat_checkout_popup_message_OM')]),
    validation: /^\d{10}$/
  },
  RU: {
    message: translate('billing.tax_promote.include_your_vat_number'),
    placeholder: translate('billing.vat_number'),
    prefix: 'RU',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_RU')
  },
  SA: {
    message: translate('billing.tax_promote_default'),
    placeholder: translate('billing.vat_number'),
    prefix: 'SA',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat.vat_cat2_checkbox_desc'),
    validation: checkSABNNumber
  },
  RS: {
    message: translate('billing.vat_header_val_RS'),
    placeholder: translate('billing.vat_number'),
    validation: /^\d{9}$/,
    taxExempt: true,
    isEmptiable: true
  },
  SG: {
    message: translate('billing.not_gst_tips'),
    placeholder: translate('billing.gst_number'),
    prefix: 'GST',
    checkbox: translate('billing.not_gst_registered'),
    tooltip: translate('billing.gst_checkbox_desc'),
    validation: checkSGBNNumber
  },
  ZA: {
    message: translate('billing.tax_promote_vat_cat1'),
    placeholder: translate('billing.vat_number'),
    validation: checkZABNNumber,
    isEmptiable: true
  },
  CH: {
    message: translate('billing.tax_promote_vat_cat1'),
    placeholder: translate('billing.vat_number'),
    validation: window.checkVATNumber,
    isEmptiable: true
  },
  TW: {
    message: translate('billing.vat_header_val_TW'),
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_TW'),
    validation: /^\d{8}$/
  },
  TZ: {
    message: translate('billing.vat_header_val_TZ'),
    placeholder: 'VRN',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_BD'),
    validation: /^\d{2}-\d{6}-[A-Z]$/
  },
  TH: {
    message: translate('billing.vat.msg_th'),
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat.vat_cat2_checkbox_desc'),
    validation: /^\d{13}$/
  },
  TR: {
    message: translate('billing.tax_promote_tr'),
    placeholder: translate('billing.tax_input_placeholder'),
    prefix: 'VAT',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.tax_checkbox_desc_template', [translate('billing.tax_checkbox_desc_tr')]),
    validation: /^\d{10,11}$/
  },
  UG: {
    message: translate('billing.ugMsg'),
    placeholder: 'TIN',
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_KHM'),
    validation: /^\d{10}$/
  },
  UA: {
    message: translate('billing.vat_header_val_UKR'),
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message', [translate('billing.vat_checkout_popup_message_UKR')]),
    validation: /^\d{9}$|^\d{10}$|^\d{12}$/
  },
  UZ: {
    message: translate('billing.tax_promote_tr'),
    placeholder: translate('billing.vat_number'),
    checkbox: translate('billing.tax_checkbox_by'),
    tooltip: translate('billing.uzCheckboxMsg'),
    validation: /^\d{12}$/,
    isEmptiable: true,
    revert: true
  },
  AE: {
    message: translate('billing.tax_promote_vat_cat1'),
    placeholder: translate('billing.vat_number'),
    validation: checkAEBNNumber,
    isEmptiable: true
  },
  VN: {
    message: translate('billing.vat_header_val_VNM'),
    placeholder: translate('billing.tax_input_placeholder'),
    checkbox: translate('billing.not_vat_registered'),
    tooltip: translate('billing.vat_checkout_popup_message_VNM'),
    validation: /^\d{10}$/
  },
  GB: {
    message: translate('billing.vat.GB_message'),
    tooltip: translate('billing.vat.UK_tootip'),
    validation: window.checkVATNumber
  },
  IM: {
    message: translate('billing.vat.GB_message'),
    tooltip: translate('billing.vat.local_tootip')
  }
})

export const COUNTRY_REPLACEMENT = {
  MC: 'FR',
  IM: 'GB'
}
